// extracted by mini-css-extract-plugin
module.exports = {"muiCheckbox":"CheckBox_muiCheckbox__gfBIa","muiLabel":"CheckBox_muiLabel__kdw0A"};